import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { OpenAIOptionsInterface } from '../../../../app/interfaces/ProviderOptionsInterface';

export interface OpenAIOptionsProps {
  options: OpenAIOptionsInterface;
  onChange: (options: OpenAIOptionsInterface) => void;
}

const OpenAIOptions: React.FunctionComponent<OpenAIOptionsProps> = (props: OpenAIOptionsProps) => {
  const { options, onChange } = props;
  const { t } = useTranslation();

  const responseFormatOptions = [
    { label: t('provider_options.openai.response_format_types.text'), value: 'text' },
    { label: t('provider_options.openai.response_format_types.json'), value: 'json_object' }
  ];

  const handleJsonModeToggle = (checked: boolean) => {
    onChange({
      ...options,
      jsonMode: checked,
      // If JSON mode is enabled, ensure responseFormat is set to json_object
      responseFormat: checked 
        ? { type: 'json_object' } 
        : options.responseFormat
    });
  };

  const handleResponseFormatChange = (value: string) => {
    onChange({
      ...options,
      responseFormat: { type: value },
      // If json_object is selected, automatically enable jsonMode for consistency
      jsonMode: value === 'json_object' ? true : options.jsonMode
    });
  };

  return (
    <div className="openai-options">
      <h4 className="text-lg mb-2">{t('provider_options.openai.title')}</h4>
      
      <div className="p-field-checkbox mb-3">
        <Checkbox
          inputId="openai-json-mode"
          checked={options.jsonMode || false}
          onChange={(e) => handleJsonModeToggle(e.checked)}
        />
        <label htmlFor="openai-json-mode" className="ml-2">
          {t('provider_options.openai.json_mode')}
        </label>
      </div>

      <div className="p-field mb-3">
        <label htmlFor="openai-response-format" className="block mb-1">
          {t('provider_options.openai.response_format')}
        </label>
        <Dropdown
          id="openai-response-format"
          value={options.responseFormat?.type || 'text'}
          options={responseFormatOptions}
          onChange={(e) => handleResponseFormatChange(e.value)}
          className="w-full"
        />
      </div>

      {/* Additional OpenAI-specific options can be added here */}
    </div>
  );
};

export default OpenAIOptions;